export default __webpack_public_path__ + "static/media/ic_eng_flag.60d72af6.svg";